var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"ma-0 pa-0"},[_vm._v(" "+_vm._s([_vm.tablePrefix, _vm.tableNumber, _vm.tableSuffix].join(''))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }